import { useState, useEffect } from "react";
import {
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Grid,
    Autocomplete,
    TextField, 
} from "@mui/material"; 
import { PetModal } from "./PetModal";
import { ClassificationAPI } from "../api/ClassificationAPI";
import { useForm, Controller } from "react-hook-form";
import { ServiceAPI } from "../api/ServiceAPI";
import { toast } from "react-toastify";

export const ServiceModal = ({ open, onClose, onSuccess, currrentClassification }) => {
    const [loading, setLoading] = useState(false);
    const [classifications, setClassifications] = useState({});

    const defaultValues = {
        pet_id: "",
        service_id: "",
    };

    const { control, handleSubmit, reset } = useForm({ defaultValues });

    useEffect(() => {
        if (open && !currrentClassification) {
            loadInitialData();
        }

        if(currrentClassification && open) {
            setClassifications(currrentClassification);
        }
    }, [open]);

    const loadInitialData = async () => {
        setLoading(true);
        const result = await ClassificationAPI.getClassifications();
        if (result.success) {
            setClassifications(result.data || {});
        }
        setLoading(false);
    };

    const submitService = async (data) => {
        const result = await ServiceAPI.createServices(data);
        if (result.success) {
            reset();
            onSuccess();
            onClose()
            return toast.success(result.message);
        } else {
            return toast.error(result.message);
        }
    };

    const autocompleteProps = {
        PopoverProps: {
            sx: {
                zIndex: 999999,
            },
        },
    };

    return (
        <PetModal
            open={open}
            onClose={onClose}
            title="Novo Atendimento"
            size="middle"
            formId="service-form"
            loading={loading}
        >
            <form id="service-form" onSubmit={handleSubmit(submitService)}>
                <Grid container spacing={3} flexDirection='column'>
                    <Grid item xs={12}>
                        <Controller
                            name="pet_id"
                            control={control}
                            render={({ field: { onChange, value, ...fieldProps } }) => {
                                const options = classifications?.pets?.map(p => ({
                                    label: p.name,
                                    id: p.id
                                })) || [];

                                return (
                                    <Autocomplete
                                        options={options}
                                        {...fieldProps}
                                        value={options.find(opt => opt.id === value) || null}
                                        onChange={(_, newValue) => onChange(newValue?.id || '')}
                                        getOptionLabel={(option) => option?.label || ''}
                                        isOptionEqualToValue={(option, val) => option.id === val?.id}
                                        renderInput={(params) => <TextField {...params} label="Pet" />}
                                        sx={{ width: '100%' }}
                                        {...autocompleteProps}
                                    />
                                );
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Controller
                            name="service_id"
                            control={control}
                            render={({ field: { onChange, value, ...fieldProps } }) => {
                                const options = classifications?.services?.map(s => ({
                                    label: `${s.name} - R$ ${s.cost}`,
                                    id: s.id
                                })) || [];

                                return (
                                    <Autocomplete
                                        options={options}
                                        {...fieldProps}
                                        value={options.find(opt => opt.id === value) || null}
                                        onChange={(_, newValue) => onChange(newValue?.id || '')}
                                        getOptionLabel={(option) => option?.label || ''}
                                        isOptionEqualToValue={(option, val) => option.id === val?.id}
                                        renderInput={(params) => <TextField {...params} label="Serviço" />}
                                        sx={{ width: '100%' }}
                                        {...autocompleteProps}
                                    />
                                );
                            }}
                        />
                    </Grid>
                </Grid>
            </form>
        </PetModal>
    );
};